import { Card, CardContent, CardContentProps, CardDescriptionProps, CardHeaderProps, CardProps } from "semantic-ui-react";

type BPCardProps = CardProps & {};

export function BPCard(props: BPCardProps) {
    return <Card {...props}>{props.children}</Card>;
}

type BPCardContentProps = CardContentProps & {};

export function BPCardContent(props: BPCardContentProps) {
    return <CardContent {...props}>{props.children}</CardContent>;
}

type BPCardHeaderProps = CardHeaderProps & {};

export function BPCardHeader(props: BPCardHeaderProps) {
    return <Card.Header {...props}>{props.children}</Card.Header>;
}

type BPCardDescriptionProps = CardDescriptionProps & {};

export function BPCardDescription(props: BPCardDescriptionProps) {
    return <Card.Description {...props}>{props.children}</Card.Description>;
}